"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setSoftKeyboardShrinksPage = exports.setKeyboardMightBeOpen = exports.hideKeyboard = exports.UNFOCUS_ELEMENT_ID = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var UNFOCUS_ELEMENT_ID = 'unfocusElement';
exports.UNFOCUS_ELEMENT_ID = UNFOCUS_ELEMENT_ID;
var keyboardMightBeOpen = false;

var hideKeyboard = function hideKeyboard() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (force || keyboardMightBeOpen) {
    var unfocusElement = document.getElementById(UNFOCUS_ELEMENT_ID);

    if (unfocusElement) {
      unfocusElement.focus();
      unfocusElement.blur();
    }

    keyboardMightBeOpen = false;
  }
};

exports.hideKeyboard = hideKeyboard;

var setKeyboardMightBeOpen = function setKeyboardMightBeOpen() {
  keyboardMightBeOpen = true;
};
/**
 * Android only
 */


exports.setKeyboardMightBeOpen = setKeyboardMightBeOpen;

var setSoftKeyboardShrinksPage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(shrinks) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_DeviceInfoHelper["default"].isiOS()) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            if (!(window.FCMPlugin && window.FCMPlugin.setSoftKeyboardShrinksPage)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return window.FCMPlugin.setSoftKeyboardShrinksPage(shrinks);

          case 5:
            _context.next = 10;
            break;

          case 7:
            if (!(window.SafeturePlugin && window.SafeturePlugin.setSoftKeyboardShrinksPage)) {
              _context.next = 10;
              break;
            }

            _context.next = 10;
            return window.SafeturePlugin.setSoftKeyboardShrinksPage(shrinks);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setSoftKeyboardShrinksPage(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.setSoftKeyboardShrinksPage = setSoftKeyboardShrinksPage;